import { render, staticRenderFns } from "./BaseHamburger.vue?vue&type=template&id=05d8378a&"
import script from "./BaseHamburger.vue?vue&type=script&lang=js&"
export * from "./BaseHamburger.vue?vue&type=script&lang=js&"
import style0 from "./BaseHamburger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports